import { render, staticRenderFns } from "./ActUploads__modalPhoto.vue?vue&type=template&id=32016f2b&scoped=true&"
import script from "./ActUploads__modalPhoto.vue?vue&type=script&lang=js&"
export * from "./ActUploads__modalPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32016f2b",
  null
  
)

export default component.exports